import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useIntl } from "gatsby-plugin-intl";

import "./select-field.scss";

const UNDERLINED = "underlined";
const OUTLINED = "outlined";
const UNDERLINED2 = "underlined2";

const variantClasses = {
  [UNDERLINED]: "border-b border-gray-700 focus:border-primary",
  [OUTLINED]: "border border-gray-200 px-3 focus:border-primary",
  [UNDERLINED2]: "border-b border-gray-300 focus:border-primary",
};

const SelectField = ({
  defaultValue,
  options,
  inputRef,
  variant = "underlined",
  className,
  wrapperClassName,
  noArrow,
  validationError,
  ...props
}) => {
  const [value, setValue] = useState();
  const { formatMessage } = useIntl();
  const classes = classNames(
    "select-field text-base focus:outline-none rtl:text-right",
    variantClasses[variant],
    className,
    { "no-arrow": noArrow }
  );

  return (
    <div
      className={classNames("input-wrapper", wrapperClassName, {
        "px-5 py-2 rounded-md": variant === UNDERLINED2,
      })}
    >
      <select
        {...props}
        value={value}
        defaultValue=""
        ref={inputRef}
        className={classes}
        onChange={e => setValue(e.target.value)}
      >
        <option disabled value="">
          -- 
          {' '}
          {formatMessage({ id: "general.select-default" })}
          {' '}
          --
        </option>
        {options.map(option => (
          <option value={option.value} key={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {validationError && (
        <span className="mt-1 block text-red-500">
          {validationError.message}
        </span>
      )}
    </div>
  );
};

SelectField.propTypes = {
  defaultValue: PropTypes.string,
  variant: PropTypes.string,
  className: PropTypes.string,
  wrapperClassName: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)),
  inputRef: PropTypes.func,
};

export default SelectField;
